import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=65713ca9"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65713ca9')) {
      api.createRecord('65713ca9', component.options)
    } else {
      api.reload('65713ca9', component.options)
    }
    module.hot.accept("./badge.vue?vue&type=template&id=65713ca9", function () {
      api.rerender('65713ca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/badge.vue"
export default component.exports